/** @jsx jsx */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { jsx } from '@emotion/core';

import Button from 'components/Button';
import ROUTES from 'constants/routes';
import { ICustomTheme } from 'interfaces';

type TProps = {
  id: number;
};

const Footer = ({ id }: TProps) => {
  const { t } = useTranslation();

  return (
    <Button
      role="footer"
      component={Link}
      to={`${ROUTES.CHALLENGE}/${id}${ROUTES.DECLARE}`}
      css={(theme: ICustomTheme) => ({
        width: 'auto !important',
        position: 'fixed',
        bottom: '2vh',
        boxShadow: theme.shadows[3],
        left: '50vw',
        transform: 'translateX(-50%)',
        zIndex: 42,
        maxWidth: '80%',
        margin: 0,
      })}
      color="secondary"
    >
      {t('challenges.declaration.history.made_a_declaration')}
    </Button>
  );
};

export default Footer;
